import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from './Organization.scss';
import TeamCard from './TeamCard';
const cx = classnames.bind(styles);
const TeamsSection = ({ teams, canEditOrganization, }) => (React.createElement("section", { key: "organization-teams", className: cx('container--teams') },
    React.createElement("h2", { className: cx('title') }, "Teams"),
    !teams?.length ? (React.createElement("p", { className: cx('no-data-message') }, canEditOrganization
        ? "You don't have any teams yet, please create one from Admin Settings > Teams"
        : "You don't have any teams yet, please contact the Organization admin")) : (React.createElement("ul", null, teams?.map((teamInfo) => (React.createElement(TeamCard, { key: teamInfo.id, id: teamInfo.id, name: teamInfo.title, memberCount: teamInfo.$memberCount ?? 0, instrumentCount: teamInfo.$deviceCount ?? 0, protocolCount: teamInfo.$protocolCount ?? 0 })))))));
export default memo(TeamsSection);
